import { render } from "./prefissiModal.vue?vue&type=template&id=16f70cba&scoped=true&ts=true"
import script from "./prefissiModal.vue?vue&type=script&lang=ts"
export * from "./prefissiModal.vue?vue&type=script&lang=ts"

import "./prefissiModal.vue?vue&type=style&index=0&id=16f70cba&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f70cba"]])

export default __exports__